import { useEffect, useState } from 'react';
import DocumentMeta from 'react-document-meta';

import config from '../../config';

const meta = {
  title: 'Recursos | Aborto gratuito con medicamentos',
  description: '',
  meta: {
    charset: 'utf-8',
    name: {
      keywords: '',
    },
    property: {
      'og:title': 'Recursos | Aborto gratuito con medicamentos',
      'og:description': '',
      'og:image': '',
    },
  },
};

export default function Resources() {
  const [cmsData, setCmsData] = useState(undefined);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${config.contentBaseUrl}/content/item/esresources`,
        );
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();
        if (result._id) {
          console.log(result);
          setCmsData(result);
        }
      } catch (error) {
        console.log(error.message);
      } finally {
        //
      }
    };

    fetchData();
  }, []);

  if (!cmsData) {
    return null;
  }
  return (
    <DocumentMeta {...meta}>
      <div className="page-title dark-background text-start contact-bg">
        <div className="container position-relative">
          <h1>{cmsData.title || ''}</h1>
        </div>
      </div>
      <section className="section py-0">
        <div className="container section-title pt-3 pb-20">
          <div
            className="row gy-4 cms-content"
            dangerouslySetInnerHTML={{ __html: cmsData.content || '' }}
          ></div>
        </div>
      </section>
    </DocumentMeta>
  );
}
